<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/project' }">
                项目管理
            </el-breadcrumb-item>
            <el-breadcrumb-item>发布项目</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="form-box">
            <div class="form-title text-center" style="margin-bottom: 40px;">
                发布项目需求
                <div class="form-title__extra">
                    <el-button
                        size="medium"
                        @click="goPage('/index/project/batch')"
                        type="text"
                    >
                        批量发布
                    </el-button>
                </div>
            </div>
            <div class="pro-info-box">
                <div class="box">
                    <div class="box__label">项目名称</div>
                    <div class="box__item">
                        <el-input
                            v-model="name"
                            style="width: 240px;"
                            placeholder="请输入项目名称"
                        ></el-input>
                    </div>
                </div>
                <div class="box">
                    <div class="box__label">预计完成时间</div>
                    <div class="box__item">
                        <el-date-picker
                            v-model="selectDate"
                            type="date"
                            :picker-options="pickerOptions"
                            placeholder="请选择预计完成时间"
                        >
                        </el-date-picker>
                    </div>
                </div>
            </div>
            <div class="creator">
                <div class="creator__hd flex-box">
                    <div class="column">
                        服务内容
                    </div>
                    <div class="column">
                        单位
                    </div>
                    <div class="column">
                        服务要求
                    </div>
                    <div class="column">
                        预估人数
                    </div>
                    <div class="column">
                        预估单价
                    </div>
                    <div class="column">
                        操作
                    </div>
                </div>
                <div class="creator__bd">
                    <div
                        class="creator__item flex-box"
                        v-for="(item, index) in items"
                        :key="index"
                    >
                        <div class="column content-ellipsis">
                            <el-tooltip
                                class="item"
                                popper-class="pro-ellipsis"
                                effect="dark"
                                :content="item.name"
                            >
                                <span>{{ item.name }}</span>
                            </el-tooltip>
                        </div>
                        <div class="column">
                            {{ item.unit }}
                        </div>
                        <div class="column content-ellipsis">
                            <el-tooltip
                                class="item"
                                popper-class="pro-ellipsis"
                                effect="dark"
                                :content="item.demand"
                            >
                                <span>{{ item.demand }}</span>
                            </el-tooltip>
                        </div>
                        <div class="column">
                            {{ item.amount }}
                        </div>
                        <div class="column">
                            {{ item.price }}
                        </div>
                        <div class="column">
                            <div v-if="preAdd.status === 0">
                                <span
                                    class="icon-wraper icon-edit"
                                    @click="editExist(index)"
                                    ><i class="el-icon-edit-outline"></i
                                ></span>
                                <span
                                    class="icon-wraper icon-delete"
                                    @click="deleteExist(index)"
                                    ><i class="el-icon-delete"></i
                                ></span>
                            </div>
                        </div>
                    </div>
                    <div class="creator__item flex-box" v-if="preAdd.status">
                        <div
                            class="column"
                            @click="servicePicker = true"
                            style="cursor: pointer"
                        >
                            <el-input
                                placeholder="请选择服务内容"
                                suffix-icon="el-icon-arrow-down"
                                style="cursor: pointer !important;"
                                v-model="serviceName"
                                :readonly="true"
                            >
                            </el-input>
                        </div>
                        <div class="column">
                            <el-input
                                placeholder="请选择服务内容"
                                v-model="preAdd.unit"
                                style="width: 160px;"
                                :disabled="true"
                            >
                            </el-input>
                        </div>
                        <div class="column">
                            <el-input
                                placeholder="请选择服务内容"
                                v-model="preAdd.demand"
                                :disabled="true"
                            >
                            </el-input>
                        </div>
                        <div class="column">
                            <el-input
                                placeholder="请填写预估人数"
                                v-model="preAdd.amount"
                            >
                            </el-input>
                        </div>
                        <div class="column">
                            <el-input
                                placeholder="请填写预估单价"
                                disabled="disabled"
                                v-model="preAdd.price"
                            >
                            </el-input>
                        </div>
                        <div class="column">
                            <span
                                class="icon-wraper icon-cancel"
                                @click="cancelAdd"
                                ><i class="el-icon-error"></i
                            ></span>
                            <span
                                class="icon-wraper icon-query"
                                @click="queryAdd"
                                ><i class="el-icon-success"></i
                            ></span>
                        </div>
                    </div>
                    <div
                        class="creator-extra-bar"
                        v-if="preAdd.status === 0"
                        @click="newPreAdd"
                    >
                        <i class="el-icon-circle-plus-outline"></i>
                        <el-button type="text">增加服务内容</el-button>
                    </div>
                </div>
                <div class="creator_ft">
                    <div class="box">
                        <el-button @click="goPage(`/index/project`)"
                            >取消</el-button
                        >
                    </div>
                    <div class="box">
                        <el-button
                            type="primary"
                            :disabled="items.length === 0"
                            @click="onSubmit"
                            >下一步</el-button
                        >
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            title="请点击选择服务内容"
            class="service-picker"
            :close-on-click-modal="false"
            :visible.sync="servicePicker"
        >
            <div class="service-box">
                <div
                    :class="item.disabled ? 'service disabled' : 'service'"
                    v-for="(item, index) in categories"
                    :key="index + 'a'"
                    @click="catSelected(item.id)"
                >
                    <el-tooltip :content="item.name" placement="top-end">
                        <div class="service-inner">
                            {{ item.no }} - {{ item.name }}
                        </div>
                    </el-tooltip>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import qs from 'qs'
import router from '@/router'

export default {
    name: 'Add',
    inject: ['goPage'],
    data () {
        return {
            servicePicker: false,
            pickerOptions: {
                disabledDate (time) {
                    return time.getTime() < Date.now()
                }
            },
            name: '',
            complete_time: '',
            selectDate: '',
            items: [],
            preAdd: {
                id: '',
                name: '', // 服务内容
                unit: '', // 单位
                amount: '', // 预估人数
                price: '', // 预估单价
                money: '', // 项目总价
                status: 0 // 编辑状态 0 不可编辑 1 可编辑
            },
            curCategory: {},
            categories: []
        }
    },
    mounted () {
        this.getCategories()
    },
    computed: {
        serviceName: {
            get: function () {
                if (this.preAdd.id === '') {
                    return ''
                } else {
                    return `${this.preAdd.id} - ${this.preAdd.name}`
                }
            },
            set: function (newValue) {
                this.preAdd.id = newValue
            }
        }
    },
    methods: {
        getCategories () {
            this.$http
                .get('/api/user/service/lists', {
                    params: {
                        status: 4,
                        size: 200
                    }
                })
                .then(res => {
                    if (res.code === 0) {
                        res.data.listData.forEach(item => {
                            item.disabled = false
                        })
                        this.categories = res.data.listData
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                    // this.$Message.error('网络错误，请稍候再试。');
                })
        },
        catSelected (e) {
            let detail = this.categories.filter(item => item.id === e)[0]
            if (detail.disabled === false) {
                this.preAdd.id = detail.id
                this.preAdd.name = detail.name
                this.preAdd.unit = detail.unit
                this.preAdd.demand = detail.demand
                this.servicePicker = false
                this.categories.forEach(item => {
                    if (detail.id === item.id) {
                        item.disabled = true
                    }
                })
            }
        },
        cancelAdd () {
            this.categories.forEach(item => {
                if (this.preAdd.id === item.id) {
                    item.disabled = false
                }
            })
            this.preAdd = {
                id: '',
                name: '',
                unit: '',
                amount: '',
                price: '',
                money: '',
                status: 0
            }
        },
        queryAdd () {
            if (this.preAdd.id === '') {
                this.$message.error('请选择服务内容')
            } else if (!/^[1-9]\d*$/.test(this.preAdd.amount)) {
                this.$message.error('请填写正确的预估人数')
            } else if (this.preAdd.amount < 0 || this.preAdd.amount > 100000) {
                this.$message.error('请填写正确的预估人数')
            } else if (
                !/^((0{1}\.\d+)|([1-9]\d*\.{1}\d+)|([1-9]+\d*))$/.test(
                    this.preAdd.price
                )
            ) {
                this.$message.error('请填写正确的预估单价')
            } else {
                this.items.push(this.preAdd)
                this.preAdd = {
                    id: '',
                    name: '',
                    unit: '',
                    amount: '',
                    price: '',
                    money: '',
                    status: 0
                }
            }
        },
        newPreAdd () {
            this.preAdd = {
                id: '',
                name: '',
                unit: '',
                amount: '',
                price: '1.00',
                money: '',
                status: 1
            }
        },
        onSubmit () {
            this.complete_time = this.getDateFromPicker(this.selectDate)
            if (this.name === '') {
                this.$message.error('请填写项目名称')
            } else if (this.name.length > 100) {
                this.$message.error('项目名称不能超过100字')
            } else if (!this.complete_time) {
                this.$message.error('请选择预计完成时间')
            } else if (this.items.length === 0) {
                this.$message.error('请至少添加一项服务内容')
            } else {
                this.$http
                    .post(
                        '/api/user/project/prefork',
                        qs.stringify({
                            name: this.name,
                            complete_time: this.complete_time,
                            service: JSON.stringify(this.items)
                        })
                    )
                    .then(res => {
                        if (res.code === 0) {
                            localStorage.setItem(
                                'PREADD',
                                JSON.stringify(res.data)
                            )
                            router.push(
                                `/index/project/commit?id=${res.data.id}`
                            )
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        // this.$Message.error('网络错误，请稍候再试。');
                    })
            }
        },
        deleteExist (e) {
            this.items.splice(e, 1)
        },
        editExist (e) {
            this.preAdd = this.items[e]
            this.items.splice(e, 1)
        },
        changeCompleteTime (e) {
            this.complete_time = this.getDateFromPicker(e)
        },
        getDateFromPicker (date) {
            return date !== ''
                ? `${date.getFullYear()}-${date.getMonth() +
                      1}-${date.getDate()}`
                : ''
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../assets/style/var";
@import "../../assets/style/sub.scss";
.form-title {
    position: relative;
    .form-title__extra {
        position: absolute;
        top: -12px;
        right: 25px;
        button {
            font-size: 14px;
            font-weight: bold;
        }
    }
}

.service-box {
    margin: -10px -20px;

    .service {
        padding: 0 20px;
        line-height: 45px;
        height: 45px;
        font-size: 12px;
        overflow: hidden;
        cursor: pointer;

        &.disabled {
            color: #9b9b9b;
            cursor: not-allowed;
            &:hover {
                background-color: #8cc5ff;
            }
        }

        .service-inner {
            text-overflow: ellipsis;
            overflow: hidden;
            height: 45px;
            white-space: nowrap;
        }

        &:nth-child(2n) {
            background-color: #f5f5f5;
        }

        &:hover {
            background-color: $--color-primary;
            color: #fff;
        }
    }
}
</style>
